function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7,25.6v26.5H8.6c-3.8,0-6.9-2.9-7.1-6.7V7.8C1.5,4.3,4.7,1.5,8.6,1.5h59.4c3.9,0,6.9,2.8,6.9,6.3v9.1H28.2c-6,0-10.5,3.8-10.5,8.7Z",
  fill: "#f08438",
  stroke: "#f08438",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M98.8,67.9c-.2,3.8-3.3,6.7-7.1,6.6h-4.3l5.7,12.8-20.4-12.8H32.2c-3.7,0-6.8-2.9-6.9-6.6,0,0,0,0,0,0V30.2c0-3.6,3.1-6.5,6.7-6.4,0,0,.1,0,.2,0h59.4c3.9,0,7.1,2.8,7.1,6.4v37.7Z",
  fill: "#f08438",
  stroke: "#f08438",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
function SvgOneToChatActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.3 91.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneToChatActivated);
export default __webpack_public_path__ + "static/media/One-to-chat-activated.8799dee9.svg";
export { ForwardRef as ReactComponent };